import React from "react";
import styled, { css } from "styled-components";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader, IfPermitted } from "components/common";
import CollectionsList from "collections/components/CollectionsList";
import CreateCollectionButton from "collections/components/CreateCollectionButton";
import HelpPopoverButton from "components/common/HelpPopoverButton";
import { InvalidLicenseWarning } from "license/LicenseCheck";
import { LICENSE_SUBJECTS } from "license/constants";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import { useTranslation } from "react-i18next";
const StyledBulletList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.md};
    margin-bottom: ${theme.spacings.xs};
    margin-left: ${theme.spacings.xs};
  `
);
const StyledInfoList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    margin-bottom: ${theme.spacings.xs};
    margin-left: ${theme.spacings.xs};
    list-style-type: none;
  `
);
const StyledHeader = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.xs};
  `
);
const CollectionsPage = () => {
  const { t } = useTranslation("enterprise_collections");
  const {
    data: { valid: hasValidLicense }
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.enterprise);
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("shared.collections") }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: /* @__PURE__ */ React.createElement(StyledHeader, null, /* @__PURE__ */ React.createElement("span", null, t("shared.collections")), /* @__PURE__ */ React.createElement(
        HelpPopoverButton,
        {
          bsSize: "small",
          helpText: /* @__PURE__ */ React.createElement(StyledBulletList, null, /* @__PURE__ */ React.createElement("li", null, t("collections_page.help_sharing")), /* @__PURE__ */ React.createElement("li", null, t("collections_page.help_removing_sharing")), /* @__PURE__ */ React.createElement("li", null, t("collections_page.help_add_entities")), /* @__PURE__ */ React.createElement("li", null, t("collections_page.help_modify_content")), /* @__PURE__ */ React.createElement("li", null, t("collections_page.help_admins_only")), /* @__PURE__ */ React.createElement("li", null, t("collections_page.help_default_collection")), /* @__PURE__ */ React.createElement("li", null, t("collections_page.help_grouping")))
        }
      )),
      topActions: hasValidLicense ? /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "collections:create" }, /* @__PURE__ */ React.createElement(CreateCollectionButton, { bsStyle: "primary", buttonText: t("collections_page.create") })) : void 0
    },
    /* @__PURE__ */ React.createElement(StyledInfoList, null, /* @__PURE__ */ React.createElement("li", null, t("collections_page.info_intro")), /* @__PURE__ */ React.createElement("li", null, t("collections_page.info_grouping")), /* @__PURE__ */ React.createElement("li", null, t("collections_page.info_bulk")))
  ), hasValidLicense ? /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(CollectionsList, null))) : /* @__PURE__ */ React.createElement(
    InvalidLicenseWarning,
    {
      licenseSubject: LICENSE_SUBJECTS.enterprise,
      featureName: "Collections",
      displayWarningContainer: true,
      bsStyle: "danger"
    }
  ));
};
export default CollectionsPage;
